Shopware.Component.register('riccardo-compliance-list', () => import('./page/riccardo-compliance-list'));
Shopware.Component.register('riccardo-compliance-detail', () => import('./page/riccardo-compliance-detail'));

Shopware.Module.register('riccardo-compliance', {
    type: 'plugin',
    name: 'riccardo-compliance',
    title: 'Pflichtangaben',
    description: 'CLP, GPSR, Sicherheitsdatenblätter',
    color: '#E30613',
    icon: 'regular-shield',
    entity: 'riccardo_compliance_profile',

    routes: {
        list: { component: 'riccardo-compliance-list', path: 'list' },
        detail: { component: 'riccardo-compliance-detail', path: 'detail/:id', meta: { parentPath: 'riccardo.compliance.list' }, props: { default: (route) => ({ profileId: route.params.id }) } },
        create: { component: 'riccardo-compliance-detail', path: 'create' },
    },

    navigation: [{
        id: 'riccardo-compliance',
        label: 'Pflichtangaben',
        color: '#E30613',
        path: 'riccardo.compliance.list',
        icon: 'regular-shield',
        parent: 'sw-catalogue',
        position: 80,
    }],
});
